import rimg from 'rimg-shopify';
import Header from './Header';
import layout from '../../Layout';

export default class MinimalHeader extends Header {
  constructor(options, settings) {
    super(options, settings);

    this.searchOpenClass = 'site-header-search--open';
    this.mobileSearchOpenClass = 'site-header-search--mobile-open';

    this.searchToggle = this.header.querySelector('[data-search-toggle]');
    this.searchBar = this.header.querySelector('[data-live-search]');
    this.searchInput = this.header.querySelector('[data-live-search-input]');

    this._toggleSearchBar = this._toggleSearchBar.bind(this);
    this._closeSearchBar = this._closeSearchBar.bind(this);

    this.searchTransitioning = false;

    // Show the menu briefly to get its height and then replace its style
    this.menu.setAttribute('style', 'display: block; visibility: hidden;');
    this.menu.setAttribute('style', `margin-top: -${this.menu.getBoundingClientRect().height}px;`);

    // Handle the search bar hide/reveal
    this.searchBarClick = (e) => {
      e.stopPropagation();
    };

    this._closeEsc = (e) => {
      if (e.key === 'Escape') {
        if (this.searchBar.contains(document.activeElement)) {
          this.searchToggle.focus();
        }
        this._closeSearchBar();
      }
    };

    // If reloading in the editor close the search bar so it doesn't interfere with other settings
    this._closeSearchBar();

    this.searchToggle.addEventListener('click', this._toggleSearchBar);
    this.searchBar.addEventListener('click', this.searchBarClick); // stop click from closing search
    window.addEventListener('resize', this._closeSearchBar);
    window.addEventListener('click', this._closeSearchBar);
    window.addEventListener('keydown', this._closeEsc);
  }

  _toggleSearchBar(e) {
    e.stopPropagation();
    e.preventDefault();

    if (this.header.classList.contains(this.searchOpenClass)
      || this.header.classList.contains(this.mobileSearchOpenClass)) {
      this._closeSearchBar();
    } else if (layout.isBreakpoint('XS') || layout.isBreakpoint('S')) {
      // If is XS/S, we need to add a class so that the search can pop out into a Takeover screen
      // which is handled in the LiveSearch.js file on focus of the input.
      this.header.classList.add(this.mobileSearchOpenClass);
      this.searchInput.focus();
    } else {
      this._openSearchBar();
      this.searchInput.focus();
    }
  }

  _openSearchBar() {
    if (this.searchTransitioning || this.header.classList.contains(this.searchOpenClass)) {
      return;
    }

    if (this.header.classList.contains(this.navOpenClass)) {
      this.closeNavigation();
    }

    this.searchTransitioning = true;

    this.searchAnimatingInEvent = () => {
      this.searchBar.classList.remove('animating-in');
      this.searchTransitioning = false;
      this.searchBar.removeEventListener('animationend', this.searchAnimatingInEvent);
    };

    this.header.classList.add(this.searchOpenClass);
    this.searchBar.addEventListener('animationend', this.searchAnimatingInEvent);
    this.searchBar.classList.add('animating-in');
  }

  _closeSearchBar() {
    if (this.searchTransitioning
      || (!this.header.classList.contains(this.searchOpenClass)
      && !this.header.classList.contains(this.mobileSearchOpenClass))) {
      return;
    }

    this.searchTransitioning = true;

    this.searchAnimatingOutEvent = () => {
      this.searchBar.classList.remove('animating-out');
      this.header.classList.remove(this.searchOpenClass);
      this.header.classList.remove(this.mobileSearchOpenClass);
      this.searchTransitioning = false;
      this.searchBar.removeEventListener('animationend', this.searchAnimatingOutEvent);
    };

    this.searchBar.addEventListener('animationend', this.searchAnimatingOutEvent);
    this.searchBar.classList.add('animating-out');
  }

  openNavigation() {
    if (this.searchTransitioning) {
      return;
    }

    this._closeSearchBar();
    super.openNavigation();
  }

  closeNavigation() {
    if (this.searchTransitioning) {
      return;
    }

    super.closeNavigation();
  }

  unload() {
    super.unload();
    this.searchToggle.removeEventListener('click', this._toggleSearchBar);
    this.searchBar.removeEventListener('click', this.searchBarClick);
    window.removeEventListener('resize', this._closeSearchBar);
    window.removeEventListener('click', this._closeSearchBar);
    window.removeEventListener('keydown', this._closeEsc);
  }

  sectionDeselect() {
    this.closeNavigation();
  }
}
